export default __webpack_public_path__ + "7de32c2da6f018decf8479718eb9769a.svg";